import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=a514a5b2&"
import script from "./PostForm.vue?vue&type=script&lang=js&"
export * from "./PostForm.vue?vue&type=script&lang=js&"
import style0 from "./PostForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports